import MISC from 'src/utils/helper/misc.js'

const {
  auth0ClientId, auth0DomainName, auth0RedirectUri,
  auth0LogoutRedirectUri, auth0LogoutRedirectUriForUnauthorisedUser
} = MISC.getAuth0CredDetails()

const {
    payment, agreements, submissions,
    promotions, salesReport, foundryProfile, userManagement
} = MISC.getRoleIdMapping()

export const AUTHO_LOGIN_URL = `${auth0DomainName}/authorize?response_type=code%20token&scope=openid%20profile%20email&state=State&client_id=${auth0ClientId}&redirect_uri=${auth0RedirectUri}&connection=email&login_hint=EmailAddress`
export const AUTH_LOGOUT_URL = `${auth0DomainName}/v2/logout?client_id=${auth0ClientId}&returnTo=${auth0LogoutRedirectUri}`
export const AUTH_LOGOUT_URL_FOR_UNAUTHORISED_USER = `${auth0DomainName}/v2/logout?client_id=${auth0ClientId}&returnTo=${auth0LogoutRedirectUriForUnauthorisedUser}`
export const SALES_REPORT_PERMISSION = salesReport
export const PAYMENT_PERMISSION = payment
export const AGREEMENT_PERMISSION = agreements
export const SUBMISSION_PERMISSION = submissions
export const PROMOTION_PERMISSION = promotions
export const USER_MANAGEMNT_PERMISSION = userManagement
export const FOUNDRY_PROFILE_PERMISSION = foundryProfile
